import axios from "axios";

/**
 * Cliente HTTP público (feria / landings).
 * Sin interceptores: nunca adjunta Bearer ni trata 401 como sesión expirada.
 */
const publicApi = axios.create({
    baseURL: "https://clubs-api.onrender.com/api",
    headers: {
        "Content-Type": "application/json",
    },
});

export default publicApi;
